import React from 'react'
import VendNumber, { vn, subtract } from 'vend-number'
import {
  Button,
  Modal,
  ModalActions,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { RoundedNumber } from '../../CashPaymentModal'
import { useVdCurrencyFilter } from '../../../../../ng-compat/hooks'

interface ChangeProps {
  amountToPay: RoundedNumber
  paid: VendNumber
  pay: (paid: VendNumber) => void
}

export const Change: React.FC<ChangeProps> = ({ amountToPay, paid, pay }) => {
  const vdCurrencyFilter = useVdCurrencyFilter()

  const change = subtract(amountToPay.rounded, paid)
  return (
    <Modal
      size="medium"
      dismissable
      onClose={() => pay(vn(amountToPay.rounded))}
    >
      <ModalHeader>
        <div className="vd-text-grand vd-align-center">
          Give {vdCurrencyFilter(-change)} change
        </div>
      </ModalHeader>
      <ModalActions>
        <Button
          block
          jumbo
          onClick={() => pay(vn(amountToPay.rounded))}
          variant="go"
          data-track="next-payment"
        >
          Next payment
        </Button>
      </ModalActions>
    </Modal>
  )
}
